export default __webpack_public_path__ + "static/media/Talk_IV17.4062502a.zip";